import { render, staticRenderFns } from "./IFRPDFSourcesUsers.vue?vue&type=template&id=2b8ad2e0"
import script from "./IFRPDFSourcesUsers.vue?vue&type=script&lang=js"
export * from "./IFRPDFSourcesUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports